import About from 'modules/acount/about';
import Header from 'modules/header/farm/main';

const AboutPage = () => {
  return (
    <>
      <Header title="درباره حجره" />
      <About />
    </>
  );
};

export default AboutPage;
